import { cn } from "@/lib/utils";
import { EditableText, TitleProps } from "./EditableText";

export const EditableTitle: React.FC<TitleProps> = ({
  className,
  ...props
}) => {
  return (
    <EditableText
      {...props}
      className={cn("rounded text-4xl font-semibold", className)}
    />
  );
};
